/**
 * Tooth component exports
 * All tooth components are generated using factory functions for consistency
 */

import { createToothBuccal } from './ToothBuccal'
import { createToothPalatal } from './ToothPalatal'
import { createToothLingual } from './ToothLingual'
import { createToothCrown } from './ToothCrown'

// Buccal views (Tooth1-32)
export const Tooth1 = createToothBuccal(1)
export const Tooth2 = createToothBuccal(2)
export const Tooth3 = createToothBuccal(3)
export const Tooth4 = createToothBuccal(4)
export const Tooth5 = createToothBuccal(5)
export const Tooth6 = createToothBuccal(6)
export const Tooth7 = createToothBuccal(7)
export const Tooth8 = createToothBuccal(8)
export const Tooth9 = createToothBuccal(9)
export const Tooth10 = createToothBuccal(10)
export const Tooth11 = createToothBuccal(11)
export const Tooth12 = createToothBuccal(12)
export const Tooth13 = createToothBuccal(13)
export const Tooth14 = createToothBuccal(14)
export const Tooth15 = createToothBuccal(15)
export const Tooth16 = createToothBuccal(16)
export const Tooth17 = createToothBuccal(17)
export const Tooth18 = createToothBuccal(18)
export const Tooth19 = createToothBuccal(19)
export const Tooth20 = createToothBuccal(20)
export const Tooth21 = createToothBuccal(21)
export const Tooth22 = createToothBuccal(22)
export const Tooth23 = createToothBuccal(23)
export const Tooth24 = createToothBuccal(24)
export const Tooth25 = createToothBuccal(25)
export const Tooth26 = createToothBuccal(26)
export const Tooth27 = createToothBuccal(27)
export const Tooth28 = createToothBuccal(28)
export const Tooth29 = createToothBuccal(29)
export const Tooth30 = createToothBuccal(30)
export const Tooth31 = createToothBuccal(31)
export const Tooth32 = createToothBuccal(32)

// Crown top views (Tooth1CrownTop-Tooth16CrownTop)
export const Tooth1CrownTop = createToothCrown(1, 'crown-top')
export const Tooth2CrownTop = createToothCrown(2, 'crown-top')
export const Tooth3CrownTop = createToothCrown(3, 'crown-top')
export const Tooth4CrownTop = createToothCrown(4, 'crown-top')
export const Tooth5CrownTop = createToothCrown(5, 'crown-top')
export const Tooth6CrownTop = createToothCrown(6, 'crown-top')
export const Tooth7CrownTop = createToothCrown(7, 'crown-top')
export const Tooth8CrownTop = createToothCrown(8, 'crown-top')
export const Tooth9CrownTop = createToothCrown(9, 'crown-top')
export const Tooth10CrownTop = createToothCrown(10, 'crown-top')
export const Tooth11CrownTop = createToothCrown(11, 'crown-top')
export const Tooth12CrownTop = createToothCrown(12, 'crown-top')
export const Tooth13CrownTop = createToothCrown(13, 'crown-top')
export const Tooth14CrownTop = createToothCrown(14, 'crown-top')
export const Tooth15CrownTop = createToothCrown(15, 'crown-top')
export const Tooth16CrownTop = createToothCrown(16, 'crown-top')

// Crown bottom views (Tooth17CrownBottom-Tooth32CrownBottom)
export const Tooth17CrownBottom = createToothCrown(17, 'crown-bottom')
export const Tooth18CrownBottom = createToothCrown(18, 'crown-bottom')
export const Tooth19CrownBottom = createToothCrown(19, 'crown-bottom')
export const Tooth20CrownBottom = createToothCrown(20, 'crown-bottom')
export const Tooth21CrownBottom = createToothCrown(21, 'crown-bottom')
export const Tooth22CrownBottom = createToothCrown(22, 'crown-bottom')
export const Tooth23CrownBottom = createToothCrown(23, 'crown-bottom')
export const Tooth24CrownBottom = createToothCrown(24, 'crown-bottom')
export const Tooth25CrownBottom = createToothCrown(25, 'crown-bottom')
export const Tooth26CrownBottom = createToothCrown(26, 'crown-bottom')
export const Tooth27CrownBottom = createToothCrown(27, 'crown-bottom')
export const Tooth28CrownBottom = createToothCrown(28, 'crown-bottom')
export const Tooth29CrownBottom = createToothCrown(29, 'crown-bottom')
export const Tooth30CrownBottom = createToothCrown(30, 'crown-bottom')
export const Tooth31CrownBottom = createToothCrown(31, 'crown-bottom')
export const Tooth32CrownBottom = createToothCrown(32, 'crown-bottom')

// Palatal views (ToothPalatal1-ToothPalatal16)
export const ToothPalatal1 = createToothPalatal(1)
export const ToothPalatal2 = createToothPalatal(2)
export const ToothPalatal3 = createToothPalatal(3)
export const ToothPalatal4 = createToothPalatal(4)
export const ToothPalatal5 = createToothPalatal(5)
export const ToothPalatal6 = createToothPalatal(6)
export const ToothPalatal7 = createToothPalatal(7)
export const ToothPalatal8 = createToothPalatal(8)
export const ToothPalatal9 = createToothPalatal(9)
export const ToothPalatal10 = createToothPalatal(10)
export const ToothPalatal11 = createToothPalatal(11)
export const ToothPalatal12 = createToothPalatal(12)
export const ToothPalatal13 = createToothPalatal(13)
export const ToothPalatal14 = createToothPalatal(14)
export const ToothPalatal15 = createToothPalatal(15)
export const ToothPalatal16 = createToothPalatal(16)

// Lingual views (ToothLingual17-ToothLingual32)
export const ToothLingual17 = createToothLingual(17)
export const ToothLingual18 = createToothLingual(18)
export const ToothLingual19 = createToothLingual(19)
export const ToothLingual20 = createToothLingual(20)
export const ToothLingual21 = createToothLingual(21)
export const ToothLingual22 = createToothLingual(22)
export const ToothLingual23 = createToothLingual(23)
export const ToothLingual24 = createToothLingual(24)
export const ToothLingual25 = createToothLingual(25)
export const ToothLingual26 = createToothLingual(26)
export const ToothLingual27 = createToothLingual(27)
export const ToothLingual28 = createToothLingual(28)
export const ToothLingual29 = createToothLingual(29)
export const ToothLingual30 = createToothLingual(30)
export const ToothLingual31 = createToothLingual(31)
export const ToothLingual32 = createToothLingual(32)
